import $ from "jquery";
import forEach from "lodash/forEach";
import isFunction from "lodash/isFunction";
import inflection from "inflection";
import { invariant } from "tpm-utils";
import { h, render } from "preact";
import EventEmitter from "events";
// import { initDevTools } from 'preact/debug/src/devtools'
import * as __adController from "tpm-js/ad-controller";

const settableModules = { "ad-controller": __adController };

class Placeholder {
	static replaceWithContainer(srcEl, div = null) {
		div = div || $(`<div/>`)[0];
		if (srcEl.dataset.cssclass) {
			div.classList.add(srcEl.dataset.cssclass);
		}
		$(srcEl).replaceWith(div);
		return div;
	}

	get widgetType() {
		return this.assertWidget(this.scope[this.widgetName]);
	}

	get widgetName() {
		return this.src.dataset.widget;
	}

	props(opts = {}) {
		const jsonProps = {};
		(opts.json || []).forEach((jp) => (jsonProps[jp] = true));

		let props;

		if (this.src.dataset.props) props = JSON.parse(this.src.dataset.props);
		else
			(props = {}),
				Object.getOwnPropertyNames(this.src.dataset).forEach((key) => {
					const name = inflection.camelize(key.replace("-", "_"), true);
					props[name] = this.src.dataset[key];

					if (props[name] && name in jsonProps)
						props[name] = JSON.parse(props[name]);
				});

		return props;
	}

	get containerEl() {
		return (this._containerEl =
			this._containerEl ||
			Placeholder.replaceWithContainer(
				this.src,
				this.src.dataset["_root"] &&
					document.querySelector("#" + this.src.dataset["_root"])
			));
	}

	constructor(src, scope) {
		this.src = src;
		this.scope = scope;
	}

	static all(scope, root = document) {
		return $("script[type=x-placeholder], div.x-placeholder", root)
			.map((idx, src) => {
				return new this(src, scope);
			})
			.toArray();
	}

	assertWidget(obj) {
		if (obj) return obj;

		console.warn(`${this.widgetName} not in scope`);
	}
}

class Settings {
	static load() {
		this._promise =
			this._promise ||
			Promise.all(this.all().map((settings) => settings.apply()));
		return this._promise;
	}

	static all() {
		return $("script[type=x-settings]")
			.map((idx, src) => {
				return new this(src);
			})
			.toArray();
	}

	constructor(src) {
		this.src = src;
	}

	apply() {
		const mod = settableModules[this.src.dataset.module];
		// return SystemJS.import(path)
		return Promise.resolve(mod).then((mod) => {
			invariant(
				isFunction(mod.__configure__),
				"cannot apply settings to module %s, export a __configure__(opts) function",
				this.src.dataset.module
			);
			mod.__configure__(JSON.parse(this.src.dataset.config));
		});
	}
}

class Controller {
	constructor(scope) {
		window._widgets = this;
		this._emitter = new EventEmitter();
	}

	afterInit(fn) {
		if (this._loaded) fn();
		else this._emitter.addListener("loaded", fn);
	}

	init(scope) {
		this.scope = scope;

		forEach(this.scope, (ctor, name) => {
			ctor.typeName = name;
		});

		Settings.load().then(() => {
			var firstInit = !this.placeholders;

			if (firstInit) {
				this.placeholders = Placeholder.all(this.scope);
			} else {
				this.placeholders.forEach((place) => {
					place.scope = this.scope;
				});
			}

			this.placeholders.forEach(this.instantiate.bind(this));

			// now that all components are rendered init dev tools for seamless load
			// if (initDevTools) initDevTools()

			this._emitter.emit("loaded");
			this._loaded = true;
		});
	}

	// Re-scan a subtree (e.g. content swapped in after the initial init) for
	// placeholders and instantiate just those. Already-instantiated ones are
	// invisible to the rescan: their source nodes were replaced by container
	// divs, so Placeholder.all can't find them again. New finds are appended to
	// this.placeholders to keep HMR re-init consistent with the initial scan.
	initSubtree(root) {
		const found = Placeholder.all(this.scope, root);
		this.placeholders = (this.placeholders || []).concat(found);
		found.forEach(this.instantiate.bind(this));
		return found;
	}

	instantiate(place) {
		const name = place.widgetName;
		const type = place.widgetType;

		// this is what deletes the old component in react dev tools ui
		if (place._comp) {
			render("", null, place._comp);
			$(place.containerEl).empty();
		}
		place._comp = render(
			h(type, place.props({ json: type.__json_props })),
			place.containerEl,
			place.containerEl.firstElementChild
		);
	}
}

export default Controller;
